import defaultSettings from '@/settings'

const title = defaultSettings.title || 'Vue Element Admin'

export function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}

// 修改产编辑时的名字（依据主附险）
export function setProPageTitle(to) {
  let tempTitle = to.meta.title

  if (to.name === 'Site-Product-List-Edit') {
    tempTitle = `编辑${to.query.main === 'true' ? '主险' : '附加险'}`
  } else if (to.name === 'Site-Product-List-Create') {
    tempTitle = `创建${to.query.main === 'true' ? '主险' : '附加险'}`
  }

  return tempTitle
}
